import { createContext, useContext } from 'react';

export type AuthenticationContextType = {
  isAuthenticated: boolean;
  isLoading: boolean;
  demoAuthentication: (userEmail: string) => void;
  user: string;
  logout: () => void;
};

const AuthenticationContext = createContext<AuthenticationContextType>({
  isAuthenticated: false,
  isLoading: false,
  demoAuthentication: (userEmail: string) => null,
  user: '',
  logout: () => null,
});

export const useLanguageContext = () => useContext(AuthenticationContext);

export default AuthenticationContext;
